import * as React from 'react';
import { mergeProps } from '../../merge-props/index.js';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.js';
import { useBaseUiId } from '../../utils/useBaseUiId.js';
export function usePopoverDescription(params) {
  const {
    descriptionId,
    setDescriptionId
  } = params;
  const id = useBaseUiId(descriptionId);
  const getDescriptionProps = React.useCallback((externalProps = {}) => {
    return mergeProps({
      id
    }, externalProps);
  }, [id]);
  useEnhancedEffect(() => {
    setDescriptionId(id);
    return () => {
      setDescriptionId(undefined);
    };
  }, [setDescriptionId, id]);
  return React.useMemo(() => ({
    getDescriptionProps
  }), [getDescriptionProps]);
}